import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { DatePicker } from "antd";
import QRCode from "react-qr-code";
import Swal from "sweetalert2";
import { useEncryptionMutation } from "AppQuries/company/encryption";
import Select from "react-select";
import { useGetUserCompaniesQuery } from "AppQuries/setting/company-settings";
import { useGetProjectsQuery } from "AppQuries/project/project";
const { RangePicker } = DatePicker;

const AttendanceQRCode = () => {
  const userData = useSelector(loggedInUser);

  const latRef = useRef();
  const langRef = useRef();
  const [qrValue, setQrValue] = useState("");

  const { mutate: encryptData } = useEncryptionMutation();

  const handleGenerateQR = () => {
    const lat = latRef.current.value;
    const lng = langRef.current.value;

    if (lat && lng) {
      const payload = {
        companyName: userData?.companyName,
        qrCodeText: "",
        qrCodeLatitude: Number(lat),
        qrCodeLongitude: Number(lng),
        currentLatitude: 0,
        currentLongitude: 0,
      };
      // const qrString = `CompanyCode:${userData?.companyCode},QrCodeText:null,CurrentLatitude: 0.0, CurrentLongitude: 0.0, QrCodeLatitude: ${lat}, QrCodeLongitude: ${lng}`;

      encryptData(payload, {
        onSuccess: (data) => {
          setQrValue(data);
        },
        onError: (error) => {
          console.log(error);
        },
      });

      // setQrValue(`{${qrString}}`);
    } else {
      Swal.fire({
        title: "Warning!",
        text: "Please enter latitude and longitude",
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
        confirmButtonClass: "btn btn-primary",
        okButtonClass: "",
        buttonsStyling: 1,
      });
    }
  };

  const handleDownloadQR = () => {
    const svg = document.querySelector("#qrCode svg");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");

      const downloadLink = document.createElement("a");
      downloadLink.href = pngFile;
      downloadLink.download = "attendance_qr.png";
      downloadLink.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  const [queryParams, setQueryParams] = useState({
    companyCode: null,
    projectCode: null,
  });

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const { data: companies } = useGetUserCompaniesQuery({
    userId: userData?.userID,
    companyCode: userData?.companyCode,
  });

  const compnayOptions =
    companies?.map((company) => ({
      value: company.companyCode,
      label: company.companyName,
    })) || [];

  const { data: projects, refetch: refetchProjects } = useGetProjectsQuery(
    {
      companyCode: queryParams?.companyCode,
      locationCode: userData?.selectedLocationCode,
    },
    {
      enabled: !!queryParams?.companyCode,
    }
  );

  console.log("Projects Data:", projects);

  const projectOptions =
    projects?.map((project) => ({
      value: project.projectCode,
      label: project.projectName,
    })) || [];

  const selectedCompanyHandler = (e) => {
    const companyCode = e?.value || null;
    console.log("Selected Company Code:", companyCode);
    updateQueryParams("companyCode", companyCode);

    const selectedCompany = companies?.find(
      (option) => option.companyCode === companyCode
    );

    latRef.current.value = selectedCompany?.companyLatitude || "";
    langRef.current.value = selectedCompany?.companyLongitude || "";
    setQrValue("");
  };

  const selectProjectsHandler = (e) => {
    updateQueryParams("projectCode", e?.value || null);
    const selectedProject = projects.find(
      (project) => project.projectCode === e?.value
    );

    latRef.current.value = selectedProject?.latitude || "";
    langRef.current.value = selectedProject?.longitude || "";
    setQrValue("");
  };

  useEffect(() => {
    // Reset QR value when company or project changes
    // setQrValue("");
    refetchProjects();
  }, [queryParams.companyCode, queryParams.projectCode]);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Attendance QR Code</h4>
                <h6>Manage your company Attendance QR Codes</h6>
              </div>
            </div>
          </div>

          <div className="card border-0 mt-5">
            <div className="card-body">
              <div className="form-row row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">Company </label>

                    <Select
                      className="select"
                      options={compnayOptions}
                      placeholder="Company"
                      value={compnayOptions?.find(
                        (option) => option.value === queryParams?.companyCode
                      )}
                      onChange={selectedCompanyHandler}
                      // onSelect={selectedCompanyHandler}
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        // control: (baseStyles, state) => ({
                        //   ...baseStyles,
                        //   fontSize: "12px",
                        //   width: "200px",
                        // }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">Project </label>

                    <Select
                      className="select"
                      options={projectOptions}
                      placeholder="Project"
                      value={projectOptions?.find(
                        (option) => option.value === queryParams?.projectCode
                      )}
                      onChange={selectProjectsHandler}
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        // control: (baseStyles, state) => ({
                        //   ...baseStyles,
                        //   fontSize: "12px",
                        //   width: "200px",
                        // }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row row">
                <div className="col-md-4">
                  <div className="form-group ">
                    <div className="form-floating">
                      <input
                        className="form-control"
                        ref={latRef}
                        type="number"
                        placeholder="Enter Latitude"
                        onWheel={(e) => e.target.blur()}
                        style={{ MozAppearance: "textfield" }}
                      />
                      <label className="form-label">Latitude</label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="form-floating">
                      <input
                        className="form-control"
                        ref={langRef}
                        type="number"
                        placeholder="Enter Longitude"
                        onWheel={(e) => e.target.blur()}
                        style={{ MozAppearance: "textfield" }}
                      />
                      <label className="form-label">Longitude</label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="input-blocks">
                    <button
                      type="button"
                      className="btn btn-added"
                      onClick={handleGenerateQR}
                    >
                      Generate QR
                    </button>
                  </div>
                </div>
              </div>

              {qrValue && (
                <div className="mt-4 text-center" id="qrCode">
                  <QRCode
                    value={qrValue}
                    size={200}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="H"
                  />
                  <p className="mt-2"></p>
                  <button
                    type="button"
                    className="btn btn-primary mt-3"
                    onClick={handleDownloadQR}
                  >
                    Download QR
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceQRCode;
